<template>
  <div>
    <AppraisalExternal v-if="appraisalExternal" />
    <AppraisalInternal v-if="appraisalInternal" />
    <h2 v-if="access">No tiene permisos para crear tasaciones.</h2>
  </div>
</template>

<script>
import AppraisalExternal from "@/components/Home/ContentHome/Sections/AppraisalsRoles/ExternalCommercialAppraisal.vue";
import AppraisalInternal from "@/components/Home/ContentHome/Sections/AppraisalsRoles/InternalCommercialAppraisal.vue";
import store from "@/store/index";

export default {
  components: {
    AppraisalExternal,
    AppraisalInternal
  },

  data: () => ({
    appraisalExternal: false,
    appraisalInternal: false,
    access: false
  }),

  created() {
    switch (store.state.userLogged.roles[0].rol) {
      case "ExternalCommercial":
        this.appraisalExternal = true;
        break;
      case "InternalCommercial":
        this.appraisalInternal = true;
        break;
      default:
        this.access = true;
        this.appraisalExternal = false;
        this.appraisalInternal = false;
        break;
    }
  }
};
</script>
